<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-header-actions">
                          <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                            <div class="row align-items-end">
                              <div class="col-12 col-sm-6 card-header-search-box">
                                <div class="input-group">
                                    <input class="form-control search-input" type="text" :placeholder="$t('main.search')"
                                           v-model="filter.search" @keypress.enter="onSearch">
                                    <div class="input-group-append">
                                        <button class="all-btn search-btn" @click="onSearch">
                                            <i class="fa fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                              </div>
                              <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                <div class="form-group">
                                  <label style="color: grey">{{$t("main.searchStatus")}}</label>
                                  <div class="position-relative">
                                    <select class="form-control"
                                            v-model="filter.status"
                                            @change="onChangeStatus">
                                      <option value=""></option>
                                      <option value="NotReady">{{$t("realEstate.status.notReady")}}</option>
                                      <option value="Open">{{$t("realEstate.status.open")}}</option>
                                      <option value="InCorrection">{{$t("realEstate.status.inCorrection")}}</option>
                                      <option value="Pending">{{$t("realEstate.status.pending")}}</option>
                                      <option value="AssignedToEvaluator">{{$t("realEstate.status.assignedToEvaluator")}}</option>
                                      <option value="NotFullyEvaluated">{{$t("realEstate.status.notFullyEvaluated")}}</option>
                                      <option value="Evaluated">{{$t("realEstate.status.evaluated")}}</option>
                                      <option value="Confirmed">{{$t("realEstate.status.confirmed")}}</option>
                                      <option value="Rejected">{{$t("realEstate.status.rejected")}}</option>
                                      <option value="InIdentification">{{$t("realEstate.status.inIdentification")}}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                            <div class="row align-items-end">
                              <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                <div class="form-group">
                                  <label>{{$t('client.field.province')}} <span class="red">*</span></label>
                                  <v-select
                                      label="name"
                                      v-model="province"
                                      :filterable="false"
                                      :options="provinces"
                                      @search="onProvinceSearch"
                                      @search:focus="onProvinceFocus"
                                      @change="onChangeFilterProvince"
                                  >
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                  </v-select>
                                </div>
                              </div>

                              <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                <div class="form-group">
                                  <label>{{$t('client.field.region')}} <span class="red">*</span></label>
                                  <v-select
                                      label="name"
                                      v-model="region"
                                      :filterable="false"
                                      :options="regions"
                                      @search="onRegionSearch"
                                      @search:focus="onRegionFocus"
                                      @change="onChangeFilterRegion"
                                  >
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                            <div class="row align-items-end">
                              <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                <div class="form-group">
                                  <label>{{$t("report.date.startDate")}}</label>
                                  <date-picker
                                      class="form-control"
                                      format="dd/MM/yyyy"
                                      v-model="filter.startDate"
                                      :clear-button="true"
                                  ></date-picker>
                                </div>
                              </div>

                              <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                <div class="form-group">
                                  <label>{{$t("report.date.endDate")}}</label>
                                  <date-picker
                                      class="form-control"
                                      format="dd/MM/yyyy"
                                      v-model="filter.endDate"
                                      :clear-button="true"
                                  ></date-picker>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="card-body table-responsive">
                        <div class="table-wrapper">
                          <table class="table table-hover">
                              <thead>
                              <tr>
                                  <th>#</th>
                                  <th>{{$t("realEstate.field.name")}}</th>
                                  <th>{{$t("newRealEstate.field.plus.createdBy")}}</th>
                                  <th width="12%">Қарз олувчи</th>
                                  <th width="10%">{{$t("realEstate.field.status")}} / {{$t("newRealEstate.field.plus.source")}}</th>
                                  <th width="12%">{{$t("realEstate.field.createdByAndDate")}}</th>
                                  <th>{{$t("newRealEstate.field.plus.assignedDateToAgent")}}</th>
                                  <th>{{$t("newRealEstate.field.plus.assignedDateToEvaluator")}}</th>
                                  <th width="10%">{{$t("newRealEstate.field.plus.confirmedDate")}}</th>
                                  <th width="15%">{{$t("newRealEstate.field.plus.agent")}}</th>
                                  <th v-if="hasPermission('E_BAHOLASH_REAL_ESTATE_VIEW')">
                                      {{$t("realEstate.field.action")}}
                                  </th>
                              </tr>
                              </thead>
                              <tbody v-if="!loading && results && results.data">
                              <tr v-for="result in results.data" :key="result.id">
                                  <td>
                                      {{result.id}}
                                      <button v-tooltip="'Кадастр маълумоти топилмаган. Холатни билиш учун босинг.'" class="btn btn-sm" @click="getFixError(result)" v-if="isCadastreFixError(result)">
                                          <i class="fa fa-warning"></i>
                                      </button>
                                  </td>
                                  <td>
                                      {{result.name}}
                                      <div class="text-secondary">{{result.cadastreDocNumber}}</div>
                                      <div class="text-secondary">
                                          <i class="fa fa-phone"></i>
                                          <span v-if="result.ownerPhoneNumber">{{result.ownerPhoneNumber}}</span>
                                          <span v-else-if="result.owner && result.owner.phone">{{result.owner.phone}}</span>
                                      </div>
                                      <div class="text-success" v-if="result.province">
                                          <span>{{result.province.name}},</span>
                                      </div>
                                      <div class="text-success" v-if="result.region">
                                          <span>{{result.region.name}}, </span>
                                      </div>
                                      <div class="text-success">
                                          <span>{{result.address}} </span>
                                      </div>
                                  </td>
                                  <td>
                                      <div class="text-secondary" v-html="ownerName(result)"></div>
                                  </td>
                                  <td>
                                    <div class="text-secondary" v-if="result.borrower">{{result.borrower.borrowerName}}</div>
                                  </td>
                                  <td class="text-center">
                                      <div class="text-success" v-if="result.registryInformationDto && result.registryInformationDto.bitrix24PersonDealId && result.status ==='InCorrection'">
                                        Битрих24: {{result.registryInformationDto.bitrix24PersonDealId}}
                                      </div>
                                      <real-estate-status :status="result.status" />
                                      <br/>
                                      <div v-if="result.source === 'INSIDE'" class="text-secondary">{{$t("realEstate.createType.ourselves")}}</div>
                                      <div v-if="result.source === 'ONLINE'" class="text-secondary">{{$t("realEstate.createType.online")}}</div>
                                      <div v-if="result.source === 'API_MIB'" class="text-secondary">{{$t("realEstate.createType.apiMib")}}</div>
                                      <div v-if="result.source === 'ANDROID'" class="text-secondary">{{$t("realEstate.createType.android")}}</div>
                                      <div v-if="result.source === 'API_BANK'" class="text-secondary">{{$t("realEstate.createType.api_bank")}}</div>
                                      <div v-if="result.source === 'API_BACKEND'" class="text-secondary">{{$t("realEstate.createType.api_backend")}}</div>
                                      <div v-if="result.source === 'API_ONLINE'" class="text-secondary">{{$t("realEstate.createType.api_online")}}</div>
                                      <div v-if="result.source === 'API_EXARID'" class="text-secondary">{{$t("realEstate.createType.api_exarid")}}</div>
                                      <div v-if="result.source === 'ONLINE_PLUS'" class="text-secondary">{{$t("realEstate.createType.online_plus")}}</div>
                                      <div v-if="result.source === 'EXPERT2'" class="text-secondary">{{$t("realEstate.createType.expert2")}}</div>
                                      <div v-if="result.source === 'REAL_SOFT'" class="text-secondary">{{$t("realEstate.createType.real_soft")}}</div>
                                      <div v-if="result.source === 'API_E_MONITORING'" class="text-secondary">{{$t("realEstate.createType.apiEMonitoring")}}</div>
                                       <div class="text-secondary" v-if="result.confirmedDate && result.status==='Confirmed'">{{result.confirmedDate}}</div>
                                       <div class="text-secondary" v-else-if="result.assignedToEvaluatorDate && result.status==='AssignedToEvaluator'">
                                         {{new Date(result.assignedToEvaluatorDate) | dateFormat('DD.MM.YYYY HH:mm')}}
                                       </div>
                                       <div class="text-info" v-else-if="result.status ==='Evaluated'">{{result.evlEstimatedDate}}</div>
                                       <div class="text-info" v-else-if="result.status ==='Pending'"><span v-if="result.pendingDate">{{new Date(result.pendingDate) | dateFormat('DD/MM/YYYY HH:mm')}}</span></div>
                                       <div class="text-info" v-else-if="result.status ==='Rejected' || result.status==='NotFullyEvaluated'">{{new Date(result.updatedDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                       <div class="text-info" v-else-if="result.status ==='NotReady'">{{new Date(result.createdDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                       <div class="text-info" v-else-if="result.status ==='Open'">{{new Date(result.openDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                  </td>
                                  <td>
                                      <div>
                                        <div class="text-secondary">{{result.createdBy ? result.createdBy.name : ''}}</div>
                                        <div class="text-secondary" v-if="result.bankEmployeeNumber">
                                            <i class="fa fa-phone"></i>
                                            <span >{{result.bankEmployeeNumber}}</span>
                                        </div>
                                        <div class="text-secondary" v-if="result.status ==='Rejected'">{{$t('expert2.action.reject')}}: <br> {{new Date(result.updatedDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                        <div class="text-secondary" v-else-if="result.status ==='InCorrection'">{{$t('expert2.action.inCorrection')}}: <br> {{new Date(result.updatedDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                        <div class="text-secondary" v-else-if="result.status ==='Open'">{{$t('expert2.action.open')}}: <br> {{new Date(result.openDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                        <div class="text-secondary" v-else-if="result.pendingDate">{{$t('expert2.action.pending')}}: <br> {{new Date(result.openDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                        <div v-else-if="result.statusChangeDate">{{new Date(result.statusChangeDate) | dateFormat('DD.MM.YYYY HH:mm')}}</div>
                                        <span v-else>{{new Date(result.createdDate) | dateFormat('DD.MM.YYYY HH:mm')}}</span>
                                      </div>
                                  </td>
                                  <td>
                                      <span v-if="result.agentAssignedDate">{{new Date(result.agentAssignedDate) | dateFormat('DD.MM.YYYY HH:mm')}}</span>
                                  </td>
                                  <td>
                                      <span v-if="result.assignedToEvaluatorDate">{{new Date(result.assignedToEvaluatorDate) | dateFormat('DD.MM.YYYY HH:mm')}}</span>
                                  </td>
                                  <td>
                                      <span v-if="result.confirmedDate && result.status==='Confirmed'">{{result.confirmedDate}}</span>
                                  </td>
                                  <td>
                                      <template v-if="(result.status !== 'Pending' && result.status !== 'Rejected') && result.agent && result.agent.name">
                                          <div v-html="result.agent.name"></div>
                                      </template>
                                      <template v-else-if="result.status === 'Pending' && !isCadastreFixError(result) && new Date(result.createdDate) < new Date('2025-08-28T15:44:00')">
                                          <v-select v-model="result.agent" label="text"
                                                    v-if="(result.version === 'V3' || isSourceExaridIdentification(result)) && result.source !== 'API_E_MONITORING' && hasPermission('E_BAHOLASH_REAL_ESTATE_BIND_AGENT')"
                                                    :options="agents"
                                                    :filterable="false"
                                                    @search="onAgentSearch"
                                                    @change="onAgentChange(result)"
                                                    @search:focus="onAgentFocus(result)">
                                              <template slot="option" slot-scope="option" v-if="option">
                                                  <div v-html="option.name"></div>
                                              </template>
                                              <template slot="selected-option"
                                                        v-if="result && result.agent && result.agent.name">
                                                  <div v-html="result.agent.name"
                                                       @click="$eventBus.$emit('search:focus')"></div>
                                              </template>
                                              <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                          </v-select>
                                      </template>
                                  </td>
                                  <td class="td-actions text-center">
<!--                                      <button class="all-btn add-btn table-action"-->
<!--                                              v-if="(result.status === 'Pending' && result.agent && result.agent.id) && hasPermission('E_BAHOLASH_REAL_ESTATE_BIND_AGENT')"-->
<!--                                              v-tooltip="'Жўнатиш'"-->
<!--                                              :disabled="processing"-->
<!--                                              @click="bindAgent(result)"-->
<!--                                      >-->
<!--                                          <i class="fa fa-check-circle"></i>-->
<!--                                      </button>-->
                                      <button class="all-btn delete-btn table-action"
                                              v-if="(result.status === 'Open' || result.status === 'Pending' || result.status === 'AssignedToEvaluator' || result.status === 'NotFullyEvaluated') && hasPermission('E_BAHOLASH_REAL_ESTATE_REJECT')"
                                              v-tooltip="'Рад этиш'"
                                              :disabled="processing"
                                              @click="showReject(result)"
                                      >
                                          <i class="fa fa-remove"></i>
                                      </button>
                                      <router-link :to="'/e-appraisal/real-estate/view/' + result.id"
                                                   v-tooltip="'Кўчмас мулк деталлари'"
                                                   class="all-btn view-btn table-action"
                                                   v-if="hasPermission('E_BAHOLASH_REAL_ESTATE_VIEW')">
                                          <i class="fa fa-image"></i>
                                      </router-link>
                                      <button class="all-btn delete-btn"
                                              v-tooltip="$t('realEstate.delete.title')"
                                              v-if="result.status === 'Pending' && hasPermission('E_BAHOLASH_REAL_ESTATE_DELETE')"
                                              @click="deletedRealEstate(result.id)"
                                      >
                                          <i class="fa fa-trash"></i>
                                      </button>
                                      <button class="all-btn view-btn table-action"
                                              v-if="result.status === 'Open' && hasPermission('E_BAHOLASH_REAL_ESTATE_BIND_AGENT')"
                                              v-tooltip="'Идентификацияга жунатиш'"
                                              :disabled="processing"
                                              @click="handleResendToIdentification(result)"
                                      >
                                        <i class="fa fa-refresh"></i>
                                      </button>
<!--                                      <button class="all-btn add-btn table-action"-->
<!--                                              v-if="result.status === 'Open' && (result.registryInformationDto && !result.registryInformationDto.openStatusCode) && hasPermission('E_BAHOLASH_UPLOAD_REAL_ESTATE_REGISTRY_INFORMATION_DATA')"-->
<!--                                              v-tooltip="'Маълумотларни юклаш'"-->
<!--                                              :disabled="processing"-->
<!--                                              @click="handleOpenRegistryInformationByQrCodeUrl(result)"-->
<!--                                      >-->
<!--                                        <i class="fa fa-check"></i>-->
<!--                                      </button>-->
                                      <router-link :to="'/new-real-estate-plus/view/' + result.id"
                                                   v-tooltip="'Кўчмас мулк деталлари'"
                                                   class="all-btn add-btn table-action"
                                                   v-if="result.status === 'InIdentification' && hasPermission('NEW_REAL_ESTATE_VIEW')">
                                        <i class="fa fa-image"></i>
                                      </router-link>
                                  </td>
                              </tr>
                              </tbody>
                          </table>
                        </div>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5"
                                  v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.total && results.total > 1">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page.page"
                                              :per-page="filter.page.size" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <RejectReasonModal :title="'Кўчмас мулкни бекор қилиш'"
                           :id="currentRealEstate ? currentRealEstate.id: null"
                           @handle-reject-save="handleRejectSave"
                           @handle-reject-cancel="handleRejectCancel"
        />
      <ConstructionCompletionPercentageModal @handle-completion-data="handleCompletionData"/>
    </div>
</template>

<script>

    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import bModal from "bootstrap-vue/es/components/modal/modal";
    import RejectReasonModal from "@/components/RejectReasonModal.vue";
    import DatePicker from "vuejs-datepicker";
    import ConstructionCompletionPercentageModal from "@/components/real-estate/ConstructionCompletionPercentageModal.vue";
    import RealEstateStatus from "@/components/real-estate/RealEstateStatus.vue";

    export default {
        name: "ERealEstateList",
        components: {
          RealEstateStatus,
          RejectReasonModal,
          DatePicker,
          'b-pagination': bPagination,
          'b-modal': bModal,
          ConstructionCompletionPercentageModal
        },
        data() {
            return {
                loading: false,
                processing: false,
                filter: initFilterModel(),
                agentFilter: initFilterModel(),
                results: null,
                agents: [],
                province: null,
                region: null,
                currentRealEstate: null,
                provinces: [],
                regions: [],
                filterProvince: initFilterModel(),
                filterRegion: initFilterModel(),
                requestId: null
            }
        },
        computed: {

        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('admin/new-real-estate/e-appraisal/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            onChangeStatus() {
                this.filter.page.page = 1;
                this.initList()
            },
            onSearch() {
                if(this.province && this.province.id) {
                  this.filter.provinceId = this.province.id
                }
                else {
                  delete this.filter.provinceId
                }
                if(this.region && this.region.id) {
                  this.filter.regionId = this.region.id
                }
                else {
                  delete this.filter.regionId
                }
                this.filter.page.page = 1;
                this.initList()
            },
            onAgentSearch(searchTxt, loading) {
                loading(true);
                this.agents = [];
                this.agentFilter.search = searchTxt;
                this.agentFilter.province = null;
                this.$http.post('user/agent', this.agentFilter)
                    .then(res => {
                        this.agents = res.data.data;
                        loading(false);
                        this.filter.search = '';
                    }, err => {
                        console.log(err);
                        loading(false);
                    });
            },
            onAgentFocus(data) {
                this.agentFilter.province = data.province;
                this.agents = [];
                this.agentFilter.search = '';
                this.$http.post('user/agent', this.agentFilter)
                    .then(res => {
                        this.agents = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onAgentChange(data) {
                this.agentFilter.province = data.province;
            },
            savePlusData(editData, realEstate) {
                let savePlusData = {}
                savePlusData.cadastreNumber = editData.cadastreDocNumber
                savePlusData.evlGoalType = editData.evlGoalTypeDto
                savePlusData.source = editData.source
                savePlusData.ownerPhoneNumber = editData.ownerPhoneNumber
                savePlusData.bankEmployeePhoneNumber = editData.bankEmployeeNumber
                savePlusData.requestId = editData.requestId
                savePlusData.cadastre = editData.cadastre

                this.processing = true;
                this.$http.post('v3/real-estate/save-by-base-data', savePlusData)
                    .then(res => {
                        let resData = res.data;
                        console.log(resData)
                        this.send(realEstate)
                        this.processing = false;

                    }).catch(({response}) => {
                    console.log('error')
                    console.log(response)

                    this.$swal({
                        type: 'error',
                        title: '',
                        text: response.data.message ? response.data.message : response.data
                    });

                    this.processing = false;
                })
            },
            bindAgent(realEstate) {
                if (realEstate.data && realEstate.data.values && realEstate.data.values.isCadastreError) {
                    this.processing = true
                    this.$http.get(`admin/new-real-estate/${realEstate.id}`)
                        .then(res => {
                            const editData = res.data
                            this.savePlusData(editData, realEstate)
                            this.processing = false
                        }, (e) => {
                            console.log(e)
                            this.processing = false
                        });
                } else {
                    this.send(realEstate)
                }
            },
            send(realEstate) {
                if (realEstate.agent && realEstate.agent.id) {
                    this.processing = true;
                    this.$http.post('admin/new-real-estate/e-appraisal/bind-agent', realEstate).then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.statusSuccess'),
                                type: 'success'
                            });
                            this.initList();
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t(res.data.message),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.statusError'),
                            type: 'error'
                        });
                        this.processing = false;
                    })
                }
            },
            ownerName(data) {
                let owner;
                if (data.customerClient) {
                    owner = data.customerClient
                } else if (data.owner) {
                    owner = data.owner
                } else if (data.createdBy && data.createdBy.serviceClient) {
                    owner = data.createdBy.serviceClient
                }

                if (owner && owner.type && owner.type === 'Legal') {
                    return "<b>" + (owner.firmName ? owner.firmName : " ") + "</b>" + "<br>" + (owner.fullName ? owner.fullName : " ")
                } else {
                    return owner && owner.fullName ? owner.fullName : " "
                }
            },
            showReject(result) {
              this.$eventBus.$emit('showRejectReasonModal', true)
              this.currentRealEstate = result
            },
            handleRejectSave(realEstateReasonDesc) {
              this.processing = true;
              this.$http.post('admin/real-estate/status/reject', {
                realEstateId: this.currentRealEstate.id,
                status: 'Rejected',
                reasonDesc: realEstateReasonDesc
              }).then(res => {
                if (res && res.data && res.data.status === 'SUCCESS') {
                  this.$eventBus.$emit('showRejectReasonModal', false);
                  this.$swal({
                    title: this.$t('messages.common.success'),
                    text: this.$t('messages.realEstate.statusSuccess'),
                    type: 'success'
                  });
                  this.currentRealEstate.status = 'Rejected';
                } else {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('messages.realEstate.statusWarning'),
                    type: 'warning'
                  });
                  this.$eventBus.$emit('showRejectReasonModal', false);
                }
                this.processing = false;
                this.currentRealEstate = null
              }, () => {
                this.$swal({
                  title: this.$t('messages.common.error'),
                  text: this.$t('messages.realEstate.statusError'),
                  type: 'error'
                });
                this.$eventBus.$emit('showRejectReasonModal', false);
                this.processing = false;
                this.currentRealEstate = null
              })
            },
            handleRejectCancel() {
              this.currentRealEstate = null
            },
            onChangeFilterProvince() {
                if (this.regions.length) this.regions = [];
                if (this.region) this.region = null
                this.filter.region = null
                this.filter.province = null

                if (this.province) {
                    this.filter.province = this.province.code
                }

                this.initList();
            },
            onChangeFilterRegion() {
                if (this.region) {
                    this.filter.region = this.region.code
                    this.initList();
                }
            },
            onProvinceFocus() {
              this.provinces = [];
              this.filterProvince.search = '';
              this.$http.post('/province/list', this.filterProvince)
                  .then(res => {
                    this.provinces = res.data.data;
                  }, err => {
                    console.log(err);
                  });
            },
            onProvinceSearch(searchTxt, loading) {
              loading(true);
              this.provinces = [];
              this.filterProvince.search = searchTxt;
              this.$http.post('/province/list', this.filterProvince)
                  .then(res => {
                    this.provinces = res.data.data;
                    loading(false);
                  }, err => {
                    console.log(err);
                  });
            },
            onRegionSearch(searchTxt, loading) {
              loading(true);
              this.regions = [];
              this.filterRegion.search = searchTxt;
              this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
              this.$http.post('/region/search', this.filterRegion)
                  .then(res => {
                    this.regions = res.data.data;
                    loading(false);
                  }, err => {
                    console.log(err);
                  });
            },
            onRegionFocus() {
              this.regions = [];
              this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
              this.$http.post('/region/search', this.filterRegion)
                  .then(res => {
                    this.regions = res.data.data;
                  }, err => {
                    console.log(err);
                  });
            },
            deletedRealEstate(id) {
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('messages.realEstate.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                    // cancelButtonColor: '#dd3333'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('admin/real-estate/' + id)
                        .then((res) => {
                            if (res && res.data && res.data.status === 'SUCCESS') {
                                this.$swal({
                                    title: this.$t('messages.common.success'),
                                    text: this.$t('messages.realEstate.deleteSuccess'),
                                    type: 'success'
                                });
                            } else {
                                this.$swal({
                                    title: this.$t('messages.common.warning'),
                                    text: res.data.message,
                                    type: 'warning'
                                });
                            }
                            this.processing = false;
                        }, () => {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.realEstate.deleteError'),
                                type: 'error'
                            });
                            this.processing = false;
                        });
                    }
                });
            },
            getFixError(realEstate) {
              this.processing = true;
              this.requestId = realEstate.requestId;

              this.$http.get('v3/real-estate/get-fix-error/' + realEstate.uuid)
                  .then(res => {
                    let resData = res.data;
                    if (resData.status === 'SUCCESS' && resData.data) {
                      let status = this.$t("realEstate.mapStatus.open")
                      let type = 'info'
                      if (resData.data.processStatus === 'DONE') {
                        status = this.$t("realEstate.mapStatus.done")
                        type = 'success'

                        if (this.isCadastreFixError(realEstate)) {
                          let responseFixError = resData.data;
                          responseFixError.requestId = realEstate.requestId

                          this.saveFixError(responseFixError)
                        }
                      } else if (resData.data.processStatus === 'IN_PROGRESS') {
                        status = this.$t("realEstate.mapStatus.inProgress")
                      } else if(resData.data.processStatus === 'PENDING') {
                        status = this.$t("realEstate.mapStatus.pending")
                      } else if (resData.data.processStatus === 'REJECT') {
                        status = this.$t("realEstate.mapStatus.reject")
                        type = 'warning'
                      }

                      this.$swal({
                        title: this.$t('messages.common.success'),
                        text: status,
                        type: type
                      });
                    }
                    this.processing = false;

                  }).catch(({response}) => {
                    console.log('error')
                    console.log(response)

                    this.$swal({
                      type: 'error',
                      title: '',
                      text: response.data.message ? response.data.message : response.data
                    });

                    this.processing = false;
                  })
            },
          saveFixError(responseFixError) {
            this.processing = true;
            this.$http.post('v3/real-estate/save-fix-error', responseFixError)
                .then(res => {
                  console.log(res)
                  this.processing = false;
                  this.initList()

                }).catch(({response}) => {
                  console.log('error')
                  console.log(response)

                  this.processing = false;
                  if (response.data && response.data.code === "NOT_COMPLETED") {
                    this.$eventBus.$emit('showConstructionCompletionPercentageModal');
                    return
                  }

                  this.$swal({
                    type: 'error',
                    title: '',
                    text: response.data.message ? response.data.message : response.data
                  });
            })
          },
          handleCompletionData(data) {
            this.loading = true;
            this.$http.get(`admin/v3/real-estate/${this.requestId}`)
                .then(res => {
                  const editData = res.data;
                  editData.constructionCompletion = data.constructionCompletion
                  editData.constructionCompletionDoc = data.constructionCompletionDoc

                  this.saveRealEstatePlus(editData)
                  this.loading = false;
                }, () => {
                  this.loading = false;
                })
          },
          saveRealEstatePlus(realEstate) {
            this.processing = true;
            this.$http.post('admin/v3/real-estate/save', realEstate)
                .then(res => {
                  let resData = res.data;
                  console.log(resData)
                  this.initList()
                  this.processing = false;

                }).catch(({response}) => {
              console.log('error')
              console.log(response)

              this.$swal({
                type: 'error',
                title: '',
                text: response.data.message ? response.data.message : response.data
              });

              this.processing = false;
            })
          },
          handleResendToIdentification(realEstate) {
            if (realEstate.requestId) {
              this.processing = true;
              this.$http.get('v3/real-estate/resend-identification/' + realEstate.requestId)
                  .then(res => {
                    console.log(res)
                    this.processing = false;
                    this.initList()

                  }).catch(response => {
                    console.log('error')
                    console.log(response)

                    this.processing = false;
                    this.$swal({
                      type: 'error',
                      title: '',
                      text: response.data.message ? response.data.message : response.data
                    });
              })
            }
          },
          isSourceExaridIdentification(result) {
              return result.source === 'API_EXARID' && result.status === 'Pending' && result.apiOrderDto
                  && result.apiOrderDto.discountType === 'IDENTIFICATION'
                  && result.apiOrderDto.orderType === 'ADVERTISEMENT'
          },
          isCadastreFixError(realEstate) {
            return realEstate.status === 'InCorrection'
          },
          isReSendIdentification(realEstate) {
              return realEstate.data && realEstate.data.values && realEstate.data.values.isAcceptCadastre && realEstate.data.values.isAcceptOwner && !realEstate.data.values.isCadastreError
          },
          saveByRegistryInformation(request) {
            this.processing = true;
            return (new Promise((resolve, reject) => {
              this.$http.post('v3/real-estate/registry-info/save', request)
                  .then(res => {
                    let resData = res.data;
                    this.initList()
                    this.processing = false;
                    this.$swal({
                      type: 'success',
                      title: '',
                      text: resData.message ? resData.message : resData.data
                    });
                    resolve(resData)
                  })
                  .catch(({response}) => {
                    console.log('error')
                    console.log(response)
                    this.$swal({
                      type: 'error',
                      title: '',
                      text: response.data.message ? response.data.message : response.data
                    });

                    this.processing = false;
                    reject(response)
                  })
            }))
          },
          handleOpenRegistryInformationByQrCodeUrl(realEstate) {
            if (realEstate.registryInformationDto && realEstate.registryInformationDto.qrCodeUrl) {
              window.open(realEstate.registryInformationDto.qrCodeUrl, '_blank');
            } else {
              let fixErrorRequest = {
                cadastreNumber: realEstate.cadastreDocNumber,
                description: "Текширинг qr код маълумотлари йўқ",
                requestId: realEstate.requestId,
                pinfl: realEstate.registryInformationDto.pinfl,
                tin: realEstate.registryInformationDto.inn
              }
              this.sendFixError(fixErrorRequest)
            }
          },
          sendFixError(fixErrorRequest) {
            this.processing = true;
            this.$http.post('/v3/real-estate/send-fix-error', fixErrorRequest).then(res => {
              if (res.status === 200) {
                this.initList()
              }
              this.processing = false;
            }).catch((response) => {
              console.log('error')
              console.log(response)
              this.$swal({
                icon: 'error',
                title: '',
                text: response.data.message ? response.data.message : response.data
              });

              this.processing = false;
            });
          }
        },
        created() {
            this.filterProvince.page.size = 1000;
            this.filterRegion.page.size = 1000;
            this.initList();

            this.$eventBus.$on('eRealEstateChanged', () => {
              this.initList();
            });
        }
    }
</script>

<style scoped>

</style>